"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconFontsLoaded = exports.iconFontsLoadedPromise = exports.fontsLoaded = exports.fontsLoadedPromise = exports.createMeasureEl = exports.forceSkipFontMeasurement = void 0;

var _misc = require("HubStyleTokens/misc");

var _domReady = require("../listeners/domReady");

var forceSkip = false;
var fontsHaveLoaded = false;
var iconFontsHaveLoaded = false;
/**
 * Hook for tests to skip font measurement. Must be called before `DOMContentLoaded` fires.
 */

var forceSkipFontMeasurement = function forceSkipFontMeasurement() {
  forceSkip = true;
};
/**
 * Creates a measure element with the specified content, `font-family`, and `font-weight`, and
 * appends it to `document.body`.
 *
 * @param {string} content
 * @param {string} fontFamily
 * @param {string} fontWeight
 */


exports.forceSkipFontMeasurement = forceSkipFontMeasurement;

var createMeasureEl = function createMeasureEl(content, fontFamily, fontWeight) {
  var measureEl = document.createElement('div');
  measureEl.setAttribute('aria-hidden', 'true'); // http://go/jira/CG-13204

  measureEl.textContent = content;
  measureEl.style.position = 'absolute';
  measureEl.style.top = '-999px';
  measureEl.style.fontFamily = fontFamily;
  measureEl.style.fontWeight = fontWeight;
  document.body.appendChild(measureEl);
  return measureEl;
};
/**
 * Compares the size of a set of elements that use web fonts and a corresponding set of elements
 * that use system fonts. If the elements have different sizes (indicating that the web font has
 * loaded), the mismatched elements are removed from both sets.
 *
 * @param {Array} webFontMeasureEls
 * @param {Array} sysFontMeasureEls
 */


exports.createMeasureEl = createMeasureEl;

var compareMeasureEls = function compareMeasureEls(webFontMeasureEls, sysFontMeasureEls) {
  for (var i = 0; i < webFontMeasureEls.length; i++) {
    var webFontTextWidth = webFontMeasureEls[i].offsetWidth;
    var sysFontTextWidth = sysFontMeasureEls[i].offsetWidth;

    if (webFontTextWidth !== sysFontTextWidth) {
      document.body.removeChild(webFontMeasureEls[i]);
      document.body.removeChild(sysFontMeasureEls[i]);
      webFontMeasureEls.splice(i, 1);
      sysFontMeasureEls.splice(i, 1);
    }
  }
};
/**
 * A promise that resolves when all variants of our base font (Avenir) have been loaded.
 */


var fontsLoadedPromise = new Promise(function (resolve) {
  (0, _domReady.domReady)(function () {
    if (forceSkip) {
      resolve();
      return;
    } // For each font weight, create a test element with our webfont and another with the fallback.


    var testText = 'BESbswy';
    var WEB_FONT_STACK = "\"" + _misc.WEB_FONT_REGULAR + "\", " + _misc.FALLBACK_FONT_STACK;
    var webFontMeasureEls = [];
    var sysFontMeasureEls = [];
    [_misc.WEB_FONT_REGULAR_WEIGHT, _misc.WEB_FONT_MEDIUM_WEIGHT, _misc.WEB_FONT_DEMI_BOLD_WEIGHT, _misc.WEB_FONT_BOLD_WEIGHT].forEach(function (weight) {
      webFontMeasureEls.push(createMeasureEl(testText, WEB_FONT_STACK, weight));
      sysFontMeasureEls.push(createMeasureEl(testText, _misc.FALLBACK_FONT_STACK, weight));
    });

    var poll = function poll() {
      compareMeasureEls(webFontMeasureEls, sysFontMeasureEls);

      if (webFontMeasureEls.length === 0) {
        fontsHaveLoaded = true;
        resolve();
      } else {
        setTimeout(poll, 50);
      }
    };

    poll();
  });
});
/**
 * A function that corresponds to whether `fontsLoadedPromise` has resolved.
 * @returns {boolean}
 */

exports.fontsLoadedPromise = fontsLoadedPromise;

var fontsLoaded = function fontsLoaded() {
  return fontsHaveLoaded;
};
/**
 * A promise that resolves when all variants of our icon font have been loaded.
 */


exports.fontsLoaded = fontsLoaded;
var iconFontsLoadedPromise = new Promise(function (resolve) {
  (0, _domReady.domReady)(function () {
    if (forceSkip) {
      resolve();
      return;
    } // For each font weight, create a test element with our webfont and another with the fallback.


    var testText = 'add';
    var WEB_FONT_STACK = "\"" + _misc.ICON_FONT_FAMILY + "\", " + _misc.FALLBACK_FONT_STACK;
    var webFontMeasureEls = [];
    var sysFontMeasureEls = [];
    ['normal', // spacesword-low
    'bold' // spacesword-high
    ].forEach(function (weight) {
      webFontMeasureEls.push(createMeasureEl(testText, WEB_FONT_STACK, weight));
      sysFontMeasureEls.push(createMeasureEl(testText, _misc.FALLBACK_FONT_STACK, weight));
    });

    var poll = function poll() {
      compareMeasureEls(webFontMeasureEls, sysFontMeasureEls);

      if (webFontMeasureEls.length === 0) {
        iconFontsHaveLoaded = true;
        resolve();
      } else {
        setTimeout(poll, 50);
      }
    };

    poll();
  });
});
/**
 * A function that corresponds to whether `iconFontsLoadedPromise` has resolved.
 * @returns {boolean}
 */

exports.iconFontsLoadedPromise = iconFontsLoadedPromise;

var iconFontsLoaded = function iconFontsLoaded() {
  return iconFontsHaveLoaded;
};

exports.iconFontsLoaded = iconFontsLoaded;